import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Label,
  Spinner,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import cellEditFactory from "react-bootstrap-table2-editor";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import "../../../../node_modules/react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import { postSubmitForm } from "../../../helpers/forms_helper";
import moment from "moment";
import showNotification from "../../../helpers/show_notification";
import {
  convertToLowestUnit,
  formatUnitsForReport,
  GetUpdatedDelivered,
} from "../../../helpers/units";
import printDiv from "../../../helpers/print_data";
import UpdateQuantityModal from "../../UpdateQuantityModal";

const AllItemOrders = (props) => {
  const store = localStorage.getItem("store_name");

  const { SearchBar } = Search;

  const [dateFrom, setDateFrom] = useState(() => {
    const currentDay = new Date();
    const firstDay = new Date(
      currentDay.getFullYear(),
      currentDay.getMonth(),
      1,
    );
    return firstDay;
  });
  const [dateTo, setDateTo] = useState();
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  useEffect(() => {
    const currentDay = new Date();
    setDateFrom(formatDate(currentDay));
    setDateTo(formatDate(currentDay));
    loadAllOrders();
  }, []);

  const [itemsToReceive, setItemsToReceive] = useState([]);
  const handleSetItemsForReceive = async (items) => {
    let filtered = items?.filter((data) => !data.is_received);

    if (filtered.length > 0) {
      let new_arr = filtered.map((item, ind) => {
        let obj = {
          uniqueId: `${Date.now()}-${ind + 1}`,
          name: item.name,
          category: item.category,
          sub_category: item.sub_category,
          item_id: item.item_id,
          batch: item.batch,
          remarks: "",
          delivered_quantity: item.delivered_quantity?.map(
            ({ unit, value }) => ({ unit, value }),
          ),
          quantity: item.delivered_quantity?.map(({ unit, value }) => ({
            unit,
            value,
          })),
          unit_levels: item.unit_levels,
        };
        return obj;
      });
      setItemsToReceive(new_arr);
    } else {
      setItemsToReceive([]);
    }
  };
  const [allOrders, setAllOrders] = useState([]);
  const [allOrdersFiltered, setAllOrdersFiltered] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [isLoadingOrders, setIsLoadingOrders] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );
  const pagination_options = {
    page: pageNumber,
    sizePerPage: pageSize,
    onPageChange: (page, sizePerPage) => {
      setPageNumber(page);
      setPageSize(sizePerPage);
    },
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
    hideSizePerPage: false,
    ignoreSinglePage: true,
  };
  const loadAllOrders = async () => {
    try {
      setIsLoadingOrders(true);
      let url =
        process.env.REACT_APP_BASEURL +
        "storesitemstransfer/get_all_requests_and_transfers";
      const response1 = await postSubmitForm(url, {});
      if (response1 && response1.status === 1) {
        const orderRequests = response1.data.orderRequests || [];
        const filteredRequests = store
          ? orderRequests.filter(
              (request) =>
                request.store_and_order_details &&
                request.store_and_order_details.order_requested_from &&
                request.store_and_order_details.order_requested_from.name ===
                  store,
            )
          : orderRequests;
        setAllOrders(filteredRequests);
      } else {
        setAllOrders([]);
        showNotification(response1.message, "Error");
      }
    } catch (error) {
      setAllOrders([]);
      showNotification(error, "Error");
    } finally {
      setIsLoadingOrders(false);
    }
  };
  useEffect(() => {
    if (selectedStatus) {
      if (selectedStatus === "All") {
        setAllOrdersFiltered(allOrders);
      } else {
        setAllOrdersFiltered(
          allOrders.filter((order) => order.status === selectedStatus),
        );
      }
    }
  }, [allOrders, selectedStatus]);

  const [selectedOrder, setSelectedOrder] = useState();
  const [editModal, setEditModal] = useState();
  const columns_external = [
    {
      dataField: "_id",
      hidden: true,
      csvExport: false,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return (pageNumber - 1) * pageSize + rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      csvExport: false,
    },
    {
      text: props.t("Order Id"),
      dataField: "order_id",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Order To"),
      dataField: "store_and_order_details.order_requested_to.name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Order Date"),
      dataField: "createdAt",
      formatter: (cell, row) => {
        return moment(row.createdAt).format("DD/MM/YYYY HH:mm");
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      style: { cursor: "pointer" },
    },

    {
      dataField: "status",
      text: props.t("Status"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      style: { cursor: "pointer" },
    },
    {
      dataField: "remark",
      text: props.t("Remarks"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      style: { cursor: "pointer" },
    },
    {
      dataField: "",
      text: props.t("Action"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      csvExport: false,
      formatter: (cell, row) => {
        return (
          <span className="text-primary">
            <i
              className="mdi mdi-text-box-search font-size-15"
              title="Click to View Details"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setReceiveModal(!receiveModal);
                if (
                  row.status !== "Pending" &&
                  row.status !== "Fully Received" &&
                  row.status !== "Rejected"
                ) {
                  handleSetItemsForReceive(row.received_items);
                }
                setSelectedOrder(row);
              }}
            ></i>
          </span>
        );
      },
    },
  ];

  const handleOnExpand = (row, isExpand, rowIndex, e) => {
    if (isExpand) {
      setExpanded([...expanded, row._id]);
      setSelectedOrder(row);
    } else {
      setExpanded(expanded.filter((x) => x !== row._id));
    }
  };

  const getDataForExpand = (row) => {
    switch (row.status) {
      case "Pending":
        return row.requested_items && row.requested_items;
      case "Fully Received":
        return row.received_items && row.received_items;
      default:
        return row.edited_items;
    }
  };
  const [expanded, setExpanded] = useState([]);
  const expandRow = {
    onlyOneExpanding: true,
    renderer: (row) => (
      <div>
        <BootstrapTable
          bootstrap4
          keyField="_id"
          data={getDataForExpand(row)}
          columns={columns_items}
          noDataIndication="No data to display."
          striped
          hover
          condensed
        />
      </div>
    ),
    expanded: expanded,
    onExpand: handleOnExpand,
  };

  const defaultSorted = [
    {
      dataField: "createdAt",
      order: "desc",
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = { backgroundColor: "#fffbb8", fontWeight: "500" };
    if (row.status === "Accepted") {
      style.backgroundColor = "#b8ffb9";
    } else if (row.status === "Pending") {
      style.backgroundColor = "#ffb8b8";
    } else if (row.status === "Rejected") {
      style.backgroundColor = "#f1b8ff";
    } else if (row.status === "Closed") {
      style.backgroundColor = "#b8ffb9";
    } else if (row.status === "Partially Dispatched") {
      style.backgroundColor = "#b8cdff";
    } else if (row.status === "Fully Dispatched") {
      style.backgroundColor = "#b8ffdf";
    } else if (row.status === "Partially Received") {
      style.backgroundColor = "#b8f3ff";
    }
    return style;
  };

  const [receiveModal, setReceiveModal] = useState();
  const [selectedItem, setSelectedItem] = useState();
  function ReceiveFormatter(cell, row) {
    return (
      <div className="d-flex align-items-center justify-content-between">
        <span className="me-2">{formatUnitsForReport(row.quantity)}</span>

        {selectedOrder &&
          selectedOrder.status !== "Pending" &&
          selectedOrder.status !== "Rejected" &&
          selectedOrder.status !== "Fully Received" && (
            <Button
              size="sm"
              className="btn btn-success"
              onClick={() => {
                const updatedItem = {
                  ...row,
                  quantity: row.quantity.map((item, idx) => ({
                    ...item,
                    index: idx,
                    isChecked: true,
                  })),
                };
                setSelectedItem(updatedItem);
                setEditModal(true);
              }}
            >
              <i className="mdi mdi-edit"></i>
              {props.t("Edit")}
            </Button>
          )}
      </div>
    );
  }
  const handleDownload = async () => {
    const fileName = "all_item_orders";
    const exportType = "xls";

    let data_to_export = allOrders;

    if (data_to_export) {
      var data = [];
      data_to_export.forEach(function (v) {
        data.push({
          OrderID: v.order_id,
          Order_From: v.store_and_order_details.order_requested_from.name,
          Order_To: v.store_and_order_details.order_requested_to.name,
          Date: moment(v.createdAt).format("DD/MM/YYYY HH:mm"),
          Status: v.status,
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  function compareQuantities(item) {
    const quantities = item.quantity;
    const quantitiesToCompare = item.delivered_quantity;
    const unitLevels = item.unit_levels;
    const convertedQuantities = convertToLowestUnit(unitLevels, quantities);
    const convertedQuantitiesToCompare = convertToLowestUnit(
      unitLevels,
      quantitiesToCompare,
    );

    let isPartial = false;
    if (convertedQuantities < convertedQuantitiesToCompare) {
      isPartial = true;
    }
    return isPartial;
  }

  const [isDisabled, setIsDisabled] = useState(false);
  const handleReceiveItems = async () => {
    setIsDisabled(true);
    let payload = {
      requestId: selectedOrder._id,
      receivedItems: itemsToReceive.map(({ uniqueId, ...rest }) => rest),
    };
    let isNoRemarkUpdated = false;
    for (let item of itemsToReceive) {
      isNoRemarkUpdated = compareQuantities(item);
      if (isNoRemarkUpdated && item.remarks === "") {
        showNotification(
          "Enter remarks for all variances in received items.",
          "Warning",
        );
        setIsDisabled(false);
        return;
      }
    }
    // console.log(payload);return
    let url =
      process.env.REACT_APP_BASEURL + "storesitemstransfer/receive_order";
    const response = await postSubmitForm(url, payload);
    if (response && response.status === 1) {
      setReceiveModal(!receiveModal);
      setIsDisabled(false);
      loadAllOrders();
      showNotification(response.message, "Success");
    } else {
      setIsDisabled(false);
      showNotification(response.message, "Error");
    }
  };

  const columns_to_receive = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
      editable: false,
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
    },
    {
      text: props.t("Dispatch Time"),
      dataField: "date_of_transaction",
      formatter: (cell, row) => {
        return moment(row.date_of_transaction).format("DD/MM/YYYY HH:mm");
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      editable: false,
    },
    {
      dataField: "delivered_quantity",
      text: props.t("Del. Qty."),
      editable: false,
      formatter: (cell, row) => {
        return formatUnitsForReport(row.delivered_quantity, row.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("To Receive"),
      editable: false,
      formatter: ReceiveFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      style: (cell, row, rowIndex, colIndex) => {
        if (row.status === "pending") {
          return { cursor: "default" }; // No specific style when status is pending
        } else {
          return { cursor: "pointer", background: "#ffffaa" };
        }
      },
    },
    {
      dataField: "remarks",
      text: props.t("Remarks"),
      editable: true,
      attrs: { title: "Click to Edit" },
      style: { cursor: "pointer", background: "#ffffaa" },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
  ];
  const columns_items = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
      editable: false,
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
    },
    {
      dataField: "quantity",
      text: props.t("Order Qty."),
      editable: false,
      formatter: (cell, row) => {
        return formatUnitsForReport(row.ordered_quantity || row.quantity);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
  ];

  const columns_delivered_items = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
      editable: false,
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
    },
    {
      dataField: "delivered_quantity",
      text: props.t("Delivered"),
      editable: false,
      formatter: (cell, row) => {
        return formatUnitsForReport(row.delivered_quantity, row.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Received"),
      editable: false,
      formatter: (cell, row) => {
        return formatUnitsForReport(row.receiving_quantity, row.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "date_of_receiving",
      text: props.t("Rec. Date"),
      editable: false,
      formatter: (cell, row) => {
        return moment(row.date_of_receiving).format("DD/MM/YYYY HH:mm");
      },

      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
  ];

  const handleSubmit = (quantity) => {
    let totalEntered = convertToLowestUnit(selectedItem.unit_levels, quantity);
    let totalDelivered = convertToLowestUnit(
      selectedItem.unit_levels,
      selectedItem.delivered_quantity,
    );
    let convertedQuantity = GetUpdatedDelivered(
      quantity,
      selectedItem.unit_levels,
    );
    if (totalEntered > totalDelivered) {
      showNotification("Can not receive more than delivered", "Warning");
      return;
    }

    const updatedItems = itemsToReceive.map((item) => {
      if (item.uniqueId === selectedItem.uniqueId) {
        // return selectedItem;
        return {
          ...item,
          quantity: convertedQuantity?.map(({ unit, value }) => ({
            unit,
            value: parseFloat(value),
          })),
        };
      }
      return item;
    });
    // const updatedItems = selectedOrder.edited_items.map(item => {
    //   if (item.item_id === selectedItem.item_id) {
    //     return { ...item, quantity: convertedquantity.map(({unit,value})=>({unit,value})) };
    //   }
    //   return item;
    // });
    // setSelectedOrder(prevOrder => ({
    //   ...prevOrder,
    //   edited_items: updatedItems
    // }));
    setItemsToReceive(updatedItems);
    setEditModal(false);
    setSelectedItem();
  };

  const ReceivedItems = selectedOrder?.received_items?.filter(
    (data) => data.is_received,
  );
  // console.log(selectedItem,"SI");
  // console.log(selectedRowsUnit,"SRU");
  return (
    <React.Fragment>
      {/* <Row>
            <Col lg={6}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={4}>
                        <AvField
                name="dateFrom"
                label={props.t("From Date")}
                placeholder={props.t("Select")}
                type="date"
                value={dateFrom}
                onChange={(e) => {
                  const selectedDate = e.target.value;
                  setDateFrom(formatDate(selectedDate));
                  
                  const maxDate = moment(selectedDate).add(30, 'days').format('YYYY-MM-DD');
                  const currentDate = moment().format('YYYY-MM-DD');
                  
                  if (moment(dateTo).isAfter(maxDate) || moment(dateTo).isAfter(currentDate)) {
                    setDateTo(maxDate > currentDate ? currentDate : maxDate);
                  }
                }}
                max={moment().format('YYYY-MM-DD')}
                errorMessage={props.t("Date cannot be empty.")}
                validate={{ required: { value: true } }}
              />
                      </Col>
                      <Col lg={4}>
                         <AvField
                name="dateTo"
                label={props.t("To Date")}
                placeholder={props.t("Select")}
                type="date"
                value={dateTo}
                onChange={(e) => {
                  const selectedDate = e.target.value;
                  setDateTo(formatDate(selectedDate));
                }}
                min={dateFrom}
                max={moment(dateFrom).add(30, 'days').format('YYYY-MM-DD') > moment().format('YYYY-MM-DD') 
                  ? moment().format('YYYY-MM-DD')
                  : moment(dateFrom).add(30, 'days').format('YYYY-MM-DD')}
                errorMessage={props.t("Date cannot be empty.")}
                validate={{ required: { value: true } }}
              />
                      </Col>
                      <Col lg={4}>
                        <Button
                          type="submit"
                          className="btn btn-md btn-success mt-4"
                          onClick={() => {
                            if (dateFrom && dateTo) {
                              loadAllOrders();
                            }
                          }}
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row> */}
      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              <Row className="mb-2">
                <Col sm="4">
                  <Button
                    type="submit"
                    className="btn btn-sm btn-secondary"
                    onClick={handleDownload}
                  >
                    <i className="mdi mdi-file-export"></i>{" "}
                    {props.t("Export CSV")}
                  </Button>
                  {"   "}
                  <Link
                    to="#"
                    onClick={() => {
                      printDiv("printDiv");
                    }}
                    className="btn btn-sm btn-success mr-2"
                  >
                    <i className="fa fa-print"></i> Print
                  </Link>
                  <div className="search-box mr-2 mb-2 d-inline-block">
                    <div className="position-relative"></div>
                  </div>
                </Col>
              </Row>
              <div id="printDiv">
                <CardTitle className="text-center">
                  {props.t("All Item Orders")}
                </CardTitle>

                <ToolkitProvider
                  keyField="_id"
                  data={allOrdersFiltered || []}
                  columns={columns_external}
                  bootstrap4
                  search
                  exportCSV
                >
                  {(toolkitProps) => (
                    <div>
                      <Row>
                        <Col lg={4}>
                          <SearchBar
                            {...toolkitProps.searchProps}
                            style={{ width: "300px" }}
                          />
                        </Col>
                        <Col lg={5}></Col>
                        <Col lg={3} className="text-right">
                          <select
                            name="status"
                            className="form-control"
                            value={selectedStatus}
                            onChange={(e) => {
                              setSelectedStatus(e.target.value);
                              setPageNumber(1);
                            }}
                          >
                            <option value="All">All</option>
                            <option value="Pending">Pending</option>
                            <option value="Rejected">Rejected</option>
                            <option value="Partially Dispatched">
                              Partially Dispatched
                            </option>
                            <option value="Fully Dispatched">
                              Fully Dispatched
                            </option>
                            <option value="Partially Received">
                              Partially Received
                            </option>
                            <option value="Closed">Closed</option>
                          </select>
                        </Col>
                      </Row>

                      <BootstrapTable
                        striped
                        hover
                        condensed
                        expandRow={expandRow}
                        defaultSorted={defaultSorted}
                        rowStyle={rowStyle}
                        pagination={paginationFactory(pagination_options)}
                        noDataIndication={
                          isLoadingOrders ? (
                            <Spinner size="md" />
                          ) : (
                            props.t("No data to display.")
                          )
                        }
                        {...toolkitProps.baseProps}
                      />
                    </div>
                  )}
                </ToolkitProvider>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* Details Modal starts */}
      <Modal
        size="xl"
        isOpen={receiveModal}
        toggle={() => {
          setReceiveModal(!receiveModal);
          setItemsToReceive([]);
          setSelectedOrder();
        }}
        // style={{ width: "1000px", minWidth: "1000px" }}
      >
        <ModalHeader
          toggle={() => {
            setReceiveModal(!receiveModal);
            setItemsToReceive([]);
            setSelectedOrder();
          }}
        >
          {props.t("Order Details")}
        </ModalHeader>
        <ModalBody>
          {selectedOrder && (
            <>
              <Row>
                <Col lg={12}>
                  <Card>
                    <CardBody>
                      <Row>
                        {itemsToReceive && itemsToReceive.length > 0 && (
                          <>
                            <Col lg={12}>
                              <Label>{props.t("Dispatched Items")}</Label>
                              <ToolkitProvider
                                keyField="_id"
                                data={itemsToReceive}
                                columns={columns_to_receive}
                              >
                                {(props) => (
                                  <div>
                                    <BootstrapTable
                                      {...props.baseProps}
                                      bootstrap4
                                      keyField="item_id"
                                      key="_id"
                                      cellEdit={cellEditFactory({
                                        mode: "click",
                                        blurToSave: true,
                                      })}
                                      noDataIndication="No data to display."
                                      striped
                                      hover
                                      condensed
                                    />
                                  </div>
                                )}
                              </ToolkitProvider>
                            </Col>
                            <Col lg={12} md={12} className="text-center">
                              <Label>&nbsp;</Label>
                              <br />
                              <Button
                                type="submit"
                                color="primary"
                                disabled={isDisabled}
                                style={{ width: "150px" }}
                                className="btn btn-default waves-effect waves-light "
                                onClick={handleReceiveItems}
                              >
                                {isDisabled ? (
                                  <Spinner size="sm" />
                                ) : (
                                  props.t("Receive Items")
                                )}
                              </Button>
                            </Col>
                          </>
                        )}

                        <Col lg={12}>
                          <Label>{props.t("Ordered Items")}</Label>
                          <ToolkitProvider
                            keyField="_id"
                            data={selectedOrder?.requested_items}
                            columns={columns_items}
                          >
                            {(props) => (
                              <div>
                                <BootstrapTable
                                  {...props.baseProps}
                                  bootstrap4
                                  keyField="item_id"
                                  key="_id"
                                  cellEdit={cellEditFactory({
                                    mode: "click",
                                    blurToSave: true,
                                  })}
                                  noDataIndication="No data to display."
                                  striped
                                  hover
                                  condensed
                                />
                              </div>
                            )}
                          </ToolkitProvider>
                        </Col>
                      </Row>
                      {ReceivedItems?.length > 0 && (
                        <Row>
                          <Col lg={12}>
                            <Label>Received Items</Label>
                            <ToolkitProvider
                              keyField="_id"
                              data={ReceivedItems}
                              columns={columns_delivered_items}
                            >
                              {(props) => (
                                <div>
                                  <BootstrapTable
                                    {...props.baseProps}
                                    cellEdit={cellEditFactory({
                                      mode: "click",
                                      blurToSave: true,
                                    })}
                                    noDataIndication="No data to display."
                                    striped
                                    hover
                                    condensed
                                  />
                                </div>
                              )}
                            </ToolkitProvider>
                          </Col>
                        </Row>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </>
          )}
        </ModalBody>
      </Modal>
      {/* Details Modal ends */}

      {/* Edit Quantity Modal */}
      <UpdateQuantityModal
        isOpen={editModal}
        toggle={() => setEditModal(false)}
        onSubmit={handleSubmit}
        item={selectedItem}
      />
    </React.Fragment>
  );
};

export default withRouter(connect(null, {})(withNamespaces()(AllItemOrders)));
